import { Component, OnInit } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
	selector: 'cv-custom-flags-cell',
	templateUrl: './custom-flags-cell.component.html',
	styleUrls: ['./custom-flags-cell.component.scss']
})
export class CustomFlagsCellComponent implements ICellRendererAngularComp {
	public cellValue: any;
	hasSSR: boolean;
	tooltipTitle = {
		hasSSR: 'No SSR',
		cvGuarantee: ''
	};
	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.cellValue = params.data;
		this.tooltipTitle.cvGuarantee = this.cellValue.guaranteeStateDescription;
		this.hasSSR = this.cellValue.hasSsrRules;
	}

	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}
}
